import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Don't scroll for Profile and Checkout pages
    if (
      pathname.startsWith("/profile") ||
      pathname.startsWith("/checkout")
    ) {
      return;
    }

    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;